// warn screen-reader users and everyone when link is about to open in a new tab or window

document.addEventListener("DOMContentLoaded", function () {
  function enhanceExternalLinks(container = document) {
    const externalLinks = container.querySelectorAll('a[target="_blank"]');

    externalLinks.forEach((link) => {
      // Prevent double-processing
      if (link.dataset.tabNoticeApplied) return;
      link.dataset.tabNoticeApplied = 'true';

      // 1. Security enforcement
      const currentRel = link.getAttribute('rel') || '';
      if (!currentRel.includes('noopener')) {
        link.setAttribute('rel', (currentRel + ' noopener').trim());
      }

      // 2. Check existing text content BEFORE appending
      const cleanText = link.textContent.trim();
      const lowerText = cleanText.toLowerCase();
      const alreadyHasWarning = 
        lowerText.includes('opens in') || 
        lowerText.includes('new tab') || 
        lowerText.includes('new window');

      if (!alreadyHasWarning) {
        // Create screen-reader element
        const span = document.createElement('span');
        span.className = 'visually-hidden'; // Ensure this class exists in CSS
        span.textContent = ' (opens in a new tab)';

        // Visible indicator for sighted users (hidden from screen readers)
        const iconSpan = document.createElement('span');
        iconSpan.setAttribute('aria-hidden', 'true');
        iconSpan.className = 'external-link-icon';
        iconSpan.textContent = ' ↗'; // Unicode \u2197

        // Update title FIRST using cleanText to avoid duplication
        if (!link.hasAttribute('title') && cleanText.length > 0) {
          link.setAttribute('title', `${cleanText} (opens in a new tab)`);
        }

        // Append silent visual span
        link.appendChild(iconSpan);

        // Append accessible screen reader span
        link.appendChild(span);
      }
    });
  }

  // Initial pass on existing DOM
  enhanceExternalLinks();

  // Watch for dynamically added links (AJAX, Modals, SPAs)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Element node
          if (node.matches('a[target="_blank"]')) {
            enhanceExternalLinks(node.parentElement || document);
          } else if (node.querySelector) {
            enhanceExternalLinks(node);
          }
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});